import { render, staticRenderFns } from "./scopeTerms.vue?vue&type=template&id=342ebc92"
import script from "./scopeTerms.vue?vue&type=script&lang=js"
export * from "./scopeTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports